import { isObject } from '@akerolabs/akero-vue/src/utils/helpers'
import date from '@akerolabs/akero-vue/src/utils/date'

const envs = ['production', 'staging', 'test']
const intercom = (...args) => window.Intercom(...args)
let initialised = false

/**
 * @returns {Boolean}
 * @description returns a boolean flag to determine if the intercom
 * lib should be enabled based on the current environment
 */
export const isEnabled = () => envs.indexOf(env) !== -1

/**
 * @returns {Boolean}
 * @description returns the initialised flag
 */
export const isIntialised = () => initialised

/**
 * @param {Object} session
 * @param {String} userHash
 * @description Enables the use of intercom.io
 */
export const startService = (session, userHash) => {
  if (isEnabled()) {
    if (
      isObject(session) &&
      typeof userHash === 'string' &&
      userHash.length > 0
    ) {
      const intercomData = getIntercomData(session, userHash)
      intercom('boot', intercomData)
      initialised = true
    }
  }
}

/**
 * @param {Object} session
 * @param {String} userHash
 * @returns {Object}
 * @description Returns the intercom data for the currect session
 */
export const getIntercomData = (session, userHash) => {
  const accountManager = isObject(session.account.accountManager)
    ? session.account.accountManager.name
    : session.account.accountManager

  const intercomData = {
    mongoId: session._id,
    app_id: interComIoAppId, // defined in a script tag in admin panel html
    name: session.name,
    email: session.contactDetails.email,
    user_id: session._id,
    user_hash: userHash,
    created_at: date(session.createdOn).format('X'),
    agency: session.agency.name,
    account: session.account.name,
    access_level: session.type,
    account_manager: session.account.accountManager,
    sector: session.account.industry,
    company: {
      company_id: session.account._id,
      name: session.account.name,
      created_at: date(session.account.createdOn).format('X'),
      capture: session.account.plan.capture.enabled,
      sms: session.account.plan.allowSMSMsg,
      advancedSettings: session.account.plan.advancedSettings,
      analytics: session.account.features.analytics.enabled,
      accountManager: accountManager,
      parentAgency: session.agency.name,
      sector: session.account.industry,
      appLimit: session.account.plan.appQuota,
      leadCount: session.account.leadCount,
      plan: session.account.planType,
      edition: session.account.edition,
      leadLimitEnabled: session.account.plan.leadLimitEnabled,
      leadLimitSet: session.account.plan.leadLimit,
    },
  }

  return intercomData
}

/**
 * @description Placeholder method incase we want to re-implement
 * tracking each page
 */
export const trackPage = () => {}

/**
 * @param {Object} data
 * @description Tries to send an event to intercom.io
 */
export const sendEvent = (data) => {
  /* istanbul ignore else */
  if (isEnabled() && isIntialised()) {
    try {
      const { eventName, metaData } = data
      intercom('trackEvent', eventName, metaData)
    } catch (e) /* istanbul ignore next */ {
      console.log(e)
    }
  }
}
